import react, { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';

export default function Veiculos() {
  const [lista, setlista] = useState([]);
  const [loading, setloading] = useState(false);

  // 1. busca a frota cadastrada
  useEffect(() => {
    buscarveiculos();
  }, []);

  const buscarveiculos = async () => {
    const { data, error } = await supabase
      .from('cadastro_veiculos')
      .select('*')
      .order('modelo', { ascending: true });
    
    if (!error) setlista(data);
  };

  // 2. função para cadastrar novo veículo (exclusivo admin)
  const handlecadastrarveiculo = async (e) => {
    e.preventDefault();
    setloading(true);
    const fd = new FormData(e.target);

    const { error } = await supabase
      .from('cadastro_veiculos')
      .insert([{
        marca: fd.get('marca'),
        modelo: fd.get('modelo'),
        ano: parseInt(fd.get('ano')),
        placa: fd.get('placa').toUpperCase(),
        renavam: fd.get('renavam'),
        chassi: fd.get('chassi'), // Campo chassi inserido aqui
        entidade_doador: fd.get('entidade_doador'),
        km_proxima_revisao: parseFloat(fd.get('km_revisao') || 10000)
      }]);

    if (!error) {
      alert("veículo cadastrado com sucesso!");
      buscarveiculos();
      e.target.reset();
    } else {
      alert("erro ao cadastrar: " + error.message);
    }
    setloading(false);
  };

  // 3. remover veículo
  const handleremoverveiculo = async (id, placa) => {
    if (window.confirm(`deseja remover o veículo placa ${placa}?`)) {
      const { error } = await supabase.from('cadastro_veiculos').delete().eq('id', id);
      if (!error) buscarveiculos();
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      {/* formulário de cadastro */}
      <div className="bg-white p-6 md:p-8 rounded-3xl shadow-lg border border-gray-100">
        <header className="border-b pb-4 mb-6">
          <h2 className="text-2xl font-black text-blue-900 uppercase tracking-tight">🚗 cadastro de frota</h2>
          <p className="text-xs text-gray-500 font-bold uppercase underline">controle de veículos fundo social</p>
        </header>

        <form onSubmit={handlecadastrarveiculo} className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input name="marca" placeholder="marca" className="input-field" required />
          <input name="modelo" placeholder="modelo" className="input-field" required />
          <input name="ano" type="number" placeholder="ano" className="input-field" required />
          
          <input name="placa" placeholder="placa" className="input-field font-bold border-blue-200" required />
          <input name="renavam" placeholder="renavam" className="input-field border-blue-200" required />
          {/* Campo chassi no lugar da matrícula */}
          <input name="chassi" placeholder="chassi" className="input-field border-blue-200" required />
          
          <input name="entidade_doador" placeholder="entidade doadora (ex: fundo social sp)" className="input-field md:col-span-2" required />
          <input name="km_revisao" type="number" placeholder="km próxima revisão" className="input-field" />

          <button 
            disabled={loading}
            className="md:col-span-3 bg-blue-700 hover:bg-blue-800 text-white font-black py-4 rounded-2xl shadow-xl transition-all active:scale-95"
          >
            {loading ? "processando..." : "cadastrar veículo na frota"}
          </button>
        </form>
      </div>

      {/* listagem de frota */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {lista.map((v) => (
          <div key={v.id} className="bg-white p-5 rounded-2xl shadow border-l-8 border-blue-900 flex justify-between items-center">
            <div>
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">{v.marca} {v.ano}</p>
              <h4 className="text-lg font-bold text-blue-900 uppercase">{v.modelo}</h4>
              <p className="text-sm font-mono font-bold bg-gray-100 px-2 py-1 rounded inline-block mt-1">{v.placa}</p>
              <p className="text-[9px] text-gray-500 mt-2 uppercase block">Chassi: {v.chassi}</p>
              <p className="text-[9px] text-gray-500 mt-1 uppercase">doado por: {v.entidade_doador}</p>
            </div>
            <button 
              onClick={() => handleremoverveiculo(v.id, v.placa)}
              className="text-red-600 hover:text-red-900 p-2"
              title="remover veículo"
            >
              🗑️
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
